//#region Styles
import {
    Part, Row, Column,
    TitleSection, ResumeSection, TitleSection2 
} from "components/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DataField from "views/components/Detail/DataField/DataField";
//#endregion
//#region Icons
import PenIcon from "icons/PenIcon";
import ListDataField from "views/components/Detail/ListDataField/ListDataField";
//#endregion

const ResumeStep1 = ({
    data,
    dataRelatedToForm: {
        acadReinforceTypes,
        allCampus
    }, toStep1, isDetailEvent
}) => {
    //#region Effects
    //#endregion
    //#region Functions
    const getDataPart = () => {
        const {
            acadReinforceTypeId,
            course, tutor,
            payGradeId,
            quantityVacancy,
            publicLoad
        } = data;
        const acadReinforceTypeName = acadReinforceTypes.find(({ id }) => id === acadReinforceTypeId).name;
        const dataPart = [
            [
                { 
                    field: "Tipo de refuerzo:", 
                    description: acadReinforceTypeName 
                },
                {
                    field: "Curso:",
                    description: course.name || "-"
                },
                {
                    field: "Tutor(a) cargo:",
                    description: tutor.fullName
                },
                {
                    mini: true,
                    field: "Categoría salarial:",
                    description: payGradeId || "-"
                }
            ],
            [
                {
                    field: "Vacantes:",
                    description: quantityVacancy
                }
            ]
        ];
        if (publicLoad.id === 1) {
            dataPart[1].push({ 
                field: "Público:", 
                render: (
                    <ListDataField 
                        data={publicLoad.students.publicByCampusIds
                            .map((publicCampusId) => {
                                return allCampus.find(({ id }) => {
                                    return id === publicCampusId;
                                }).name;
                            })
                        }/>
                )
            });
        }
        else if (publicLoad.id === 2) {
            dataPart[1].splice(0, 0, {
                field: "Público:", 
                description: "Archivo adjunto", 
                render: (
                    <span><strong>{publicLoad.list.studentsFile.name}</strong></span>
                )
            });
        }
        return dataPart;
    }
    //#endregion
    return (
        <Part>
            <Row>
                <Column width="max-content">
                    <TitleSection>Resumen:</TitleSection>
                    <TitleSection2>Detalles del refuerzo</TitleSection2>
                </Column>
                {!isDetailEvent && (
                    <CustomButton
                        variant="quintinary"
                        text="Editar sección"
                        icon={<PenIcon/>}
                        onClick={toStep1}/>
                )}
            </Row>
            <ResumeSection>
                {data && 
                <Part direction="row">
                    {getDataPart().map((row, idx1) => (
                        <Column key={idx1}
                            width="45%" 
                            gap="20px">
                            {row.map((item, idx2) => {
                                    return (
                                        <DataField 
                                            key={idx2}
                                            {...item}/>
                                    );
                                }
                            )}
                        </Column>    
                    ))}
                </Part>}
            </ResumeSection>
        </Part>
    );
}

export default ResumeStep1;